'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import TradeHero from './TradeHero';
import TradeHeroMobile from './TradeHeroMobile';
import Breadcrumbs from '@/app/_components/Breadcrumbs';
import { useTradeSlide } from './TradeSlideContext';
const breadcrumbs = [{
  name: 'Home',
  url: '/'
}, {
  name: 'Trade Program',
  url: '/hive-trade-program'
}];
export default function TradeHeroWrapper(t0) {
  const $ = _c(22);
  const {
    slides
  } = t0;
  const {
    currentSlide,
    setCurrentSlide
  } = useTradeSlide();
  let t1;
  let t2;
  if ($[0] !== currentSlide || $[1] !== setCurrentSlide || $[2] !== slides) {
    t1 = () => {
      if (slides?.length > 0 && !currentSlide) {
        const randomIndex = Math.floor(Math.random() * slides.length);
        setCurrentSlide(slides[randomIndex]);
      }
    };
    t2 = [slides, currentSlide, setCurrentSlide];
    $[0] = currentSlide;
    $[1] = setCurrentSlide;
    $[2] = slides;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const handleApplyClick = _temp;
  let t3;
  if ($[5] !== currentSlide) {
    t3 = <TradeHero slide={currentSlide} onApplyClick={handleApplyClick} />;
    $[5] = currentSlide;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute top-0 bottom-0 left-0 w-2/3 bg-white/[15%] mix-blend-soft-light pointer-events-none z-10" />;
    t5 = <div className="absolute top-0 bottom-0 right-0 w-1/3 bg-black/[15%] mix-blend-soft-light pointer-events-none z-10" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== currentSlide) {
    t6 = currentSlide && <div className="absolute top-0 left-0 z-20 ps-[var(--site-padding)] pt-2"><Breadcrumbs breadcrumbs={breadcrumbs} on_white_background={true} className="drop-shadow-lg" /></div>;
    $[9] = currentSlide;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="hidden md:block max-w-[1800px] mb-8 w-full relative">{t3}{t4}{t5}{t6}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== currentSlide) {
    t8 = <TradeHeroMobile slide={currentSlide} onApplyClick={handleApplyClick} />;
    $[14] = currentSlide;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute top-0 bottom-0 right-0 w-1/2 bg-black/[15%] mix-blend-soft-light pointer-events-none" />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <div className="md:hidden absolute top-0 left-0 w-screen h-[calc(50svh+var(--header-height))]">{t8}{t9}</div>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7) {
    t11 = <>{t7}{t10}</>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp() {
  const formElement = document.getElementById("trade-form");
  if (formElement) {
    formElement.scrollIntoView({
      behavior: "smooth"
    });
  }
}